<template>
  <div>
    <div class="IndexTab">
        <div>
          <div style="background: rgba(113,13,17,0.8)">
            <div class="container ">
             <div class="minShow">
               <div class="minLogoBe">
                <span class="minLogo">
                  <img src="./images/logo1.png" alt="">
                </span>
                 <p>中药堂智慧服务系统</p>
               </div>
             </div>
              <ul class="navA flex-direction fontSize14">
                <li class="marginRig40">
                  <a href="http://www.yunbiaowulian.com/ " class="colorfff">云标物联</a>
                </li>
                <li>
                  <a href="javascript:void(0);" title="云标物联" @click='addFavorite2()' class="colorfff">收藏本站</a>
                </li>
              </ul>
            </div>
          </div>
          <div style="background: rgba(255,255,255,0.5)">
            <div class="container">
              <div class="Between minBetween">
                <h2 style="margin: 0" class="logoImg"><img src="./images/logo.png" alt=""></h2>
                <div class="indexNavBot">
                  <ul class="nav navbar-nav flex align-items flex-wrap">
                    <router-link tag="li" active-class="active" class="tab-item index" to="/home" replace ><a>首页<span class="sr-only">(current)</span></a></router-link>
                    <router-link tag="li" class="tab-item" to="/corefuntion" replace><a>核心功能</a></router-link>
                    <router-link tag="li" class="tab-item" to="/system" replace><a>系统优势</a></router-link>
                    <router-link tag="li" class="tab-item" to="/hardware" replace><a >硬件配套</a></router-link>
                    <router-link tag="li" class="tab-item" to="/customercase" replace><a>客户案例</a></router-link>
                    <router-link tag="li" class="tab-item" to="/aboutus" replace><a>关于我们</a></router-link>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <!--这是内容区  路由外联-->

      <router-view></router-view>


    <bottomfix></bottomfix>
    <div class="width100 text-center footer">©2015-2017 yiliao.yunbiaowulian.com 版权所有 京ICP备：17018905号-1</div>
  </div>
</template>

<script  type="text/ecmascript-6">
  import home from './components/home/home.vue';
  import system from './components/system/system.vue';
  import corefuntion from './components/corefuntion/corefuntion.vue';
  import aboutus from './components/aboutus/aboutus.vue';
  import customercase from './components/customercase/customercase.vue';
  import hardware from './components/hardware/hardware.vue';
  import bottomfix from './components/bottomfix/bottomfix.vue';
  export default {
    components: {
      'v-home': home,
      'v-system': system,
      'v-corefuntion': corefuntion,
      'v-aboutus': aboutus,
      'v-customercase': customercase,
      'v-hardware': hardware,
      bottomfix,
    },
    methods:{
      addFavorite2() {
        var url = window.location;
        var title = document.title;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("360se") > -1) {
          alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
        } else if (ua.indexOf("msie 8") > -1) {
          window.external.AddToFavoritesBar(url, title); //IE8
        } else if (document.all) {
          try{
            window.external.addFavorite(url, title);
          }catch(e){
            alert('1您的浏览器不支持,请按 Ctrl+D 手动收藏!');
          }
        } else if (window.sidebar) {
          window.sidebar.addPanel(title, url, "");
        } else {
          alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
        }
      }

  },
  mounted() {

  }
  };
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .footer
    background: #710d11
    padding:10px 0
    color #ffffff
    margin-top: 70px;
  .IndexTab
    background: url(./images/home1.png) center no-repeat
    background-size: cover;
    .minShow
      display none
    .navA
      display:flex
      justify-content:flex-end
      flex-direction:row
      padding: 9px 31px 9px 0;
      margin-bottom 0
      a:hover,a:active{
        color:#fff;
      }
    .minBetween
      display:flex
      justify-content:space-between
      flex-direction:row
      align-items center
      .indexNavBot
        .tab-item
          &.active
            a
              background-color:rgba(113,13,17,0.8)
              color:#fff
          &.hover
            a
              background-color:rgba(113,13,17,0.8)
              color:#fff
          a
            padding:25px 30px
            color: #333
            font-size 18px
            display: block;
            text-align: center;
@media (min-width: 320px) and (max-width: 750px)

  .minLogoBe
    display:flex
    flex-direction row
    justify-content space-between
    align-items: center;
    .minLogo img
      height 30px
  .footer
    padding-bottom: 64px;
    margin-top: 0px;
  .IndexTab
    .minShow
      display block
      padding 3px 0
      p
        margin-bottom 0
        color:#fff
    .navA
      display none
    .minBetween
      display block
      .logoImg
        display none
      .indexNavBot
        .tab-item
          width:33%
          a
            width: 100%;
            font-size 16px
            margin 5px 0
            padding: 5px;

</style>



// WEBPACK FOOTER //
// src/App.vue